const crossCellBlock = $('.js-c-collection');

if (crossCellBlock) {
    // eslint-disable-next-line no-unused-vars,no-undef
    const CarouselComponent = new CarouselPlugin(crossCellBlock);
}
